module.exports = __webpack_public_path__ + "static/apple-decb038a30bad582a49f40a27121bc37.png";